/**
 * AccountingPostingRequest permissions — Accounting-owned mutations.
 * Creation is system / Collection service path (no human create permission).
 */

export const ACCOUNTING_POSTING_READ_PERMISSION = 'accounting_posting:read' as const;
export const ACCOUNTING_POSTING_REVIEW_PERMISSION = 'accounting_posting:review' as const;
export const ACCOUNTING_POSTING_APPROVE_PERMISSION = 'accounting_posting:approve' as const;
export const ACCOUNTING_POSTING_POST_PERMISSION = 'accounting_posting:post' as const;
export const ACCOUNTING_POSTING_REJECT_PERMISSION = 'accounting_posting:reject' as const;
export const ACCOUNTING_POSTING_CORRECT_PERMISSION = 'accounting_posting:correct' as const;

export const ACCOUNTING_POSTING_PERMISSIONS = [
  ACCOUNTING_POSTING_READ_PERMISSION,
  ACCOUNTING_POSTING_REVIEW_PERMISSION,
  ACCOUNTING_POSTING_APPROVE_PERMISSION,
  ACCOUNTING_POSTING_POST_PERMISSION,
  ACCOUNTING_POSTING_REJECT_PERMISSION,
  ACCOUNTING_POSTING_CORRECT_PERMISSION,
] as const;

export type AccountingPostingPermission = (typeof ACCOUNTING_POSTING_PERMISSIONS)[number];

export function isAccountingPostingPermission(
  permission: string
): permission is AccountingPostingPermission {
  return (ACCOUNTING_POSTING_PERMISSIONS as readonly string[]).includes(permission);
}
